(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["revieww"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('myfleecy-reviews')) {
  customElements.define('myfleecy-reviews', class extends HTMLElement {
    connectedCallback() {
      if (this.mfConnected) return;
      this.mfConnected = true;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.on = (el, event, fn) => el?.addEventListener(event, fn, { signal });
      this.q = sel => this.querySelector(sel);
      this.qa = sel => Array.from(this.querySelectorAll(sel));
      this.category = 'product';
      this.limit = Number(this.dataset.pageSize) || 8;
      this.pageSize = this.limit;
      this.saved = new Set();
      this.storageKey = `myfleecy-reviews:${this.dataset.sectionId}`;
      try { const values = JSON.parse(localStorage.getItem(this.storageKey) || '[]'); if (Array.isArray(values)) this.saved = new Set(values.filter(v => typeof v === 'string')); } catch (_) {}
      this.cards = this.qa('[data-review]').map((el, index) => {
        const value = el.dataset.date;
        const time = /^\d{4}-\d{2}-\d{2}$/.test(value) ? Date.parse(value + 'T00:00:00Z') : 0;
        return { el, index, id: el.dataset.reviewId, category: el.dataset.category, rating: Number(el.dataset.rating), date: Number.isFinite(time) ? time : 0, shade: el.dataset.shade, size: el.dataset.size, media: el.dataset.hasMedia === 'true', featured: el.dataset.featured === 'true', text: el.textContent.toLocaleLowerCase() };
      });
      const setOptions = (selector, key) => {
        const select = this.q(selector);
        if (!select) return;
        const values = [...new Set(this.cards.filter(c => c.category === 'product').map(c => c[key]).filter(Boolean))];
        values.sort((a,b) => a.localeCompare(b, undefined, { numeric: true }));
        values.forEach(value => select.add(new Option(value, value)));
      };
      setOptions('[data-shade]', 'shade');
      setOptions('[data-size]', 'size');
      this.on(this, 'click', event => this.handleClick(event));
      this.on(this, 'change', event => {
        if (event.target.matches('[data-sort], [data-rating], [data-shade], [data-size], [data-media-filter], [data-saved-filter]')) { this.limit = this.pageSize; this.renderReviews(); }
        if (event.target.matches('[data-variant]')) this.updateVariant(true);
      });
      this.on(this.q('[data-search]'), 'input', () => { this.limit = this.pageSize; this.renderReviews(); });
      this.qa('[data-save]').forEach(button => this.paintSave(button));
      this.renderReviews();
      this.updateVariant();
      const dialog = this.q('dialog');
      this.on(dialog, 'click', event => { if (event.target === dialog) dialog.close(); });
      this.on(dialog, 'close', () => { this.q('[data-lightbox-content]')?.replaceChildren(); this.lastZoom?.focus(); });
      if (this.q('[data-form-result]')) this.q('[data-write]').open = true;
      this.on(window, 'hashchange', () => this.openWriteFromHash());
      this.openWriteFromHash();
      this.on(document, 'shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        const card = event.target.closest('[data-review]') || event.target.querySelector('[data-review]');
        if (card) {
          this.category = card.dataset.category;
          this.resetFilters();
          this.limit = this.cards.length;
          this.renderReviews();
          card.scrollIntoView({ block: 'center' });
        }
        const detail = event.target.closest('details') || event.target.querySelector('details');
        if (detail) detail.open = true;
      });
      this.classList.add('mf-ready');
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.mfConnected = false;
      this.q('[data-shade]')?.querySelectorAll('option:not(:first-child)').forEach(el => el.remove());
      this.q('[data-size]')?.querySelectorAll('option:not(:first-child)').forEach(el => el.remove());
    }
    openWriteFromHash() {
      const write = this.q('[data-write]');
      if (write && (window.location.hash === '#' + write.id || window.location.hash === '#MFContact-' + this.dataset.sectionId)) write.open = true;
    }
    handleClick(event) {
      const target = event.target.closest('button, a');
      if (!target || !this.contains(target)) return;
      if (target.matches('[data-category]')) {
        this.category = target.dataset.category;
        this.resetFilters();
      }
      if (target.matches('[data-reset]')) this.resetFilters();
      if (target.matches('[data-rating-bar]')) {
        const select = this.q('[data-rating]');
        select.value = select.value === target.dataset.ratingBar ? 'all' : target.dataset.ratingBar;
        this.limit = this.pageSize;
        this.renderReviews();
      }
      if (target.matches('[data-more]')) {
        const oldVisible = new Set(this.cards.filter(c => !c.el.hidden).map(c => c.id));
        this.limit += this.pageSize;
        this.renderReviews();
        this.matching.find(c => !c.el.hidden && !oldVisible.has(c.id))?.el.focus({ preventScroll: true });
      }
      if (target.matches('[data-save]')) {
        const id = target.closest('[data-review]').dataset.reviewId;
        this.saved.has(id) ? this.saved.delete(id) : this.saved.add(id);
        try { localStorage.setItem(this.storageKey, JSON.stringify([...this.saved])); } catch (_) {}
        this.paintSave(target);
        if (this.q('[data-saved-filter]')?.checked) this.renderReviews();
      }
      if (target.matches('[data-zoom]') && this.q('dialog')?.showModal) {
        event.preventDefault();
        const img = document.createElement('img');
        img.src = target.href;
        img.alt = target.dataset.caption || '';
        this.q('[data-lightbox-content]').replaceChildren(img);
        this.q('[data-lightbox-caption]').textContent = target.dataset.caption || '';
        this.lastZoom = target;
        this.q('dialog').showModal();
      }
      if (target.matches('[data-close]')) this.q('dialog')?.close();
      if (target.matches('[data-gallery-src]')) {
        this.setProductImage(target.dataset.gallerySrc, target.dataset.galleryAlt);
        this.qa('[data-gallery-src]').forEach(button => button.setAttribute('aria-pressed', String(button === target)));
      }
      if (target.matches('[data-quantity]')) {
        const quantity = this.q('input[name="quantity"]');
        const min = Number(quantity.min) || 1;
        const step = Number(quantity.step) || 1;
        const max = quantity.max ? Number(quantity.max) : Infinity;
        let value = Number(quantity.value);
        if (!Number.isFinite(value)) value = min;
        const direction = target.dataset.quantity === 'plus' ? 1 : -1;
        const next = Math.max(min, Math.min(max, value + direction * step));
        quantity.value = String(min + Math.floor((next - min) / step) * step);
        quantity.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (target.matches('a[href^="#MFWrite-"]')) {
        const write = this.q('[data-write]');
        if (write) write.open = true;
      }
    }
    paintSave(button) {
      const saved = this.saved.has(button.closest('[data-review]').dataset.reviewId);
      button.setAttribute('aria-pressed', String(saved));
      button.querySelector('[data-save-label]').textContent = saved ? this.dataset.savedLabel : this.dataset.saveLabel;
    }
    resetFilters() {
      ['[data-rating]', '[data-shade]', '[data-size]'].forEach(sel => { const el = this.q(sel); if (el) el.value = 'all'; });
      ['[data-media-filter]', '[data-saved-filter]'].forEach(sel => { const el = this.q(sel); if (el) el.checked = false; });
      if (this.q('[data-search]')) this.q('[data-search]').value = '';
      if (this.q('[data-sort]')) this.q('[data-sort]').value = 'latest';
      this.limit = this.pageSize;
      this.renderReviews();
    }
    renderReviews() {
      if (!this.q('[data-dashboard]')) return;
      const source = this.cards.filter(c => c.category === this.category);
      this.qa('[data-category]').filter(el => el.tagName === 'BUTTON').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.category === this.category)));
      this.qa('[data-product-filter]').forEach(el => el.hidden = this.category !== 'product');
      const rated = source.filter(c => c.rating >= 1 && c.rating <= 5);
      const avg = rated.length ? rated.reduce((sum,c) => sum + c.rating,0) / rated.length : 0;
      this.q('[data-average]').textContent = rated.length ? Number(avg.toFixed(2)).toString() : '—';
      this.q('[data-total]').textContent = String(rated.length);
      this.q('[data-average-stars]').style.setProperty('--fill', `${avg * 20}%`);
      const rating = this.q('[data-rating]').value;
      this.qa('[data-rating-bar]').forEach(row => {
        const count = rated.filter(c => c.rating === Number(row.dataset.ratingBar)).length;
        row.querySelector('[data-bar-count]').textContent = String(count);
        row.querySelector('[data-bar-fill]').style.width = `${rated.length ? count / rated.length * 100 : 0}%`;
        row.setAttribute('aria-pressed', String(rating === row.dataset.ratingBar));
      });
      const words = (this.q('[data-search]')?.value || '').trim().toLocaleLowerCase().split(/\s+/).filter(Boolean);
      const shade = this.q('[data-shade]')?.value || 'all';
      const size = this.q('[data-size]')?.value || 'all';
      const media = this.q('[data-media-filter]')?.checked;
      const saved = this.q('[data-saved-filter]')?.checked;
      const matches = source.filter(c => (rating === 'all' || c.rating === Number(rating)) && (this.category === 'store' || shade === 'all' || c.shade === shade) && (this.category === 'store' || size === 'all' || c.size === size) && (!media || c.media) && (!saved || this.saved.has(c.id)) && words.every(word => c.text.includes(word)));
      const sort = this.q('[data-sort]').value;
      matches.sort((a,b) => {
        if (sort === 'highest' || sort === 'lowest') {
          if (a.rating === 0 && b.rating !== 0) return 1;
          if (b.rating === 0 && a.rating !== 0) return -1;
        }
        if (sort === 'highest') return b.rating - a.rating || b.date - a.date || a.index - b.index;
        if (sort === 'lowest') return a.rating - b.rating || b.date - a.date || a.index - b.index;
        if (sort === 'oldest') return (a.date || Infinity) - (b.date || Infinity) || a.index - b.index;
        if (sort === 'featured') return Number(b.featured) - Number(a.featured) || b.date - a.date || a.index - b.index;
        return b.date - a.date || a.index - b.index;
      });
      this.cards.forEach(c => { c.el.hidden = true; });
      const list = this.q('[data-list]');
      const fragment = document.createDocumentFragment();
      matches.forEach((c,i) => { c.el.hidden = i >= this.limit; if (c.el.hidden) c.el.querySelectorAll('video').forEach(v => v.pause()); fragment.append(c.el); });
      list.append(fragment);
      this.cards.filter(c => c.el.hidden).forEach(c => c.el.querySelectorAll('video').forEach(v => v.pause()));
      const shown = Math.min(this.limit, matches.length);
      this.q('[data-results]').textContent = source.length ? this.dataset.resultsLabel.replaceAll('[shown]', String(shown)).replaceAll('[total]', String(matches.length)) : this.dataset.noReviews;
      this.q('[data-empty]').hidden = matches.length > 0;
      this.q('[data-more]').hidden = matches.length <= this.limit;
      this.matching = matches;
    }
    setProductImage(src, alt) {
      const img = this.q('.mf-product-image');
      if (!img || !src) return;
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = src;
      img.alt = alt || '';
    }
    updateVariant(changeImage = false) {
      const select = this.q('[data-variant]');
      if (!select) return;
      const option = select.selectedOptions[0];
      if (!option) return;
      this.q('[data-price]').textContent = option.dataset.price;
      const compare = this.q('[data-compare]');
      compare.textContent = option.dataset.compare || '';
      compare.hidden = !option.dataset.compare;
      const available = option.dataset.available === 'true';
      this.q('[data-add]').disabled = !available;
      this.q('[data-add-label]').textContent = available ? this.dataset.addLabel : this.dataset.soldOut;
      const quantity = this.q('input[name="quantity"]');
      quantity.min = option.dataset.min || '1';
      quantity.step = option.dataset.step || '1';
      if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');
      const min = Number(quantity.min), step = Number(quantity.step), max = quantity.max ? Number(quantity.max) : Infinity;
      const value = Math.max(min, Math.min(max, Number(quantity.value) || min));
      quantity.value = String(min + Math.floor((value - min) / step) * step);
      if (changeImage && option.dataset.image) {
        this.setProductImage(option.dataset.image, option.dataset.alt);
        this.qa('[data-gallery-src]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.gallerySrc === option.dataset.image)));
      }
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
